import React, { useEffect } from "react";
import EventHeader from "../../container/event/header";
import Layout from "../../container/layout";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  bg: {
    backgroundImage: "url('/photo/bg.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "center bottom",
    [theme.breakpoints.up("xs")]: {
      padding: 16,
    },
    [theme.breakpoints.down("xs")]: {
      backgroundImage: "none",
    },
  },
  container: {
    marginTop: 64,
  },
}));

const Expired = () => {
  const classes = useStyles();

  return (
    <div className={classes.bg}>
      <div className={classes.container}>
        <Layout>
          <EventHeader
            title="กิจกรรมนี้ปิดการลงทะเบียนแล้ว"
            description={
              <>
                สามารถติดตามกิจกรรมอื่น ๆ
                หรือสอบถามรายละเอียดเพิ่มเติมได้ที่&nbsp;
                <Link
                  target="_blank"
                  style={{ textDecoration: "underline" }}
                  href="https://www.facebook.com/apthaicareer"
                >
                  AP People and Career
                </Link>
              </>
            }
          />
        </Layout>
      </div>
    </div>
  );
};

export default Expired;
